
import { Shield } from "lucide-react";

interface EnglishLoanInfoNoticesProps {
  isSubmitting: boolean;
}

export const EnglishLoanInfoNotices = ({ isSubmitting }: EnglishLoanInfoNoticesProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-start space-x-2 bg-blue-50 p-3 rounded-md">
        <Shield className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="text-xs text-blue-700">
          <p className="font-medium mb-1">Your information is secure</p>
          <p>We use SSL encryption to ensure all your data is protected. We will never share your information with unauthorized third parties.</p>
        </div>
      </div>
      
      <p className="text-xs text-center text-gray-600">
        Submitting an application will not affect your credit score. It takes just 2 minutes, and loan offers will start appearing within hours.
      </p>
    </div>
  );
};
